import { Reveal } from "@/components/Reveal";
import { ABOUT } from "@/data";

export const About = () => (
  <section id="about" data-testid="about-section" className="bg-navy noise-overlay py-24 md:py-32">
    <div className="relative z-10 mx-auto max-w-[1400px] px-5 md:px-10 grid md:grid-cols-12 gap-10">
      <Reveal className="md:col-span-4">
        <p className="font-primary uppercase tracking-[0.3em] text-gold text-xs md:text-sm mb-4">About Us</p>
        <h2 className="font-primary font-bold uppercase tracking-tighter text-ice text-5xl md:text-6xl leading-[0.9]">
          No Job Is<br /><span className="text-gold">Too Small.</span>
        </h2>
      </Reveal>
      <Reveal delay={0.1} className="md:col-span-8 md:pt-2">
        <p className="font-body text-ice/85 text-xl md:text-2xl leading-relaxed">{ABOUT}</p>
        <a
          href="#quote"
          data-testid="about-book-btn"
          className="inline-block mt-10 font-primary uppercase text-base tracking-wide bg-gold text-navy px-8 py-4 hover:shadow-[5px_5px_0px_#F4F7F6] transition-shadow"
        >
          Book Today
        </a>
      </Reveal>
    </div>
  </section>
);
